function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCondensingWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "29.83 68.05 29.83 62.19 27.51 62.19 29.83 58.74 32.32 62.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.7 68.05 40.7 62.19 38.38 62.19 40.7 58.74 43.19 62.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "51.58 68.05 51.58 62.19 49.26 62.19 51.58 58.74 54.07 62.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "51.75 14.55 51.75 20.4 54.07 20.4 51.75 23.85 49.26 20.3",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.88 14.55 40.88 20.4 43.19 20.4 40.88 23.85 38.38 20.3",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "30 14.55 30 20.4 32.32 20.4 30 23.85 27.51 20.3",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.53,45.5C52.53,50,49.14,56,40.79,56S29.05,50,29.05,45.5c0-7.86,11.74-18.71,11.74-18.71S52.53,37.64,52.53,45.5Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      stroke: "currentColor",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.51,51.67a7.12,7.12,0,0,1-5.42-.47c-3.1-1.44-3.56-3.71-3.56-3.71",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.29,
    y: 11.19,
    width: 45,
    height: 60.21,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondensingWater);
export default __webpack_public_path__ + "static/media/condensing_water.f88f4be584b92214140f7386ca4e8c3b.svg";
export { ForwardRef as ReactComponent };